import type { Category } from './categories'

const laptopArticles: Article[] = [
  {
    title: 'Best laptop deals',
    url: '/reviews/laptops/article/best-laptop-deals-a0gLg0i9nmhc',
  },
  {
    title: 'Best laptops',
    url: '/reviews/laptops/article/how-to-buy-the-best-laptop-aNXXi9d9wmfn',
  },
  {
    title: 'Best budget laptops',
    url: '/reviews/laptops/article/best-cheap-laptops-aLsgM2F0QHcg',
  },
]

export interface Article {
  title: string
  url: string
}

const mattressArticles: Article[] = [
  {
    title: 'Best mattress deals',
    url: '/reviews/mattresses/article/best-mattress-deals',
  },
  {
    title: 'Best mattresses',
    url: '/reviews/mattresses/article/how-to-buy-the-best-mattress',
  },
  {
    title: 'Best budget mattresses',
    url: '/reviews/mattresses/article/best-cheap-mattresses',
  },
]

export const CategoryToArticles: Record<Category, Article[]> = {
  laptops: laptopArticles,
  mattresses: mattressArticles,
}
